<script>
  import { PHP, alert } from "../../store";
  import TextField from "../../utils/TextField.svelte";
  import CheckBox from "../../utils/CheckBox.svelte";
  import ImageIcon from "../../new/ImageIcon.svelte";
  import Dropdown from "../../utils/Dropdown.svelte";
  import { saveSettings } from "../../api";
  import Message from "../../utils/Message.svelte";
  import { modalOptionsValidate } from "../validators";
  import validate from "validate.js";
  import to from "await-to-js";
  import {
    dialogPositions,
    dialogMobilePositions,
    dialogDirections,
    SETTING_SAVE_TYPES,
  } from "../../constants";
  export let submitSettings;
  let modalSettings = {
    isEnabled: JSON.parse($PHP.modalOptions.showDialog),
    title: $PHP.modalOptions.title,
    content: $PHP.modalOptions.content,
    acceptText: $PHP.modalOptions.acceptText,
    rejectText: $PHP.modalOptions.rejectText,
    iconUrl: $PHP.modalOptions.icon,
    position: $PHP.modalOptions.position,
    mobilePosition: $PHP.modalOptions.mobilePosition,
    retry: $PHP.modalOptions.dialogRetryRate,
    direction: $PHP.modalOptions.dialogDirection
  };
  let error = {};
  let inprogress = false;

  const save = async function(event) {
    error = validate(modalSettings, modalOptionsValidate, {
      format: "svelte",
      fullMessages: false
    });

    if (error) return;

    inprogress = true;

    await to(
      submitSettings(SETTING_SAVE_TYPES.PROMPT, {
        showDialog: modalSettings.isEnabled,
        title: modalSettings.title,
        content: modalSettings.content,
        acceptText: modalSettings.acceptText,
        rejectText: modalSettings.rejectText,
        icon: modalSettings.iconUrl,
        position: modalSettings.position,
        mobilePosition: modalSettings.mobilePosition,
        dialogRetryRate: modalSettings.retry || 0,
        dialogDirection: modalSettings.direction
      })
    );

    inprogress = false;
    return alert.setWithTimeout({
      value: "Your change successfuly saved",
      className: "is-success",
      timeout: 5000
    });
  };
</script>

<div class="container is-fluid">
  <CheckBox
    title="Show dialog"
    description="Uncheck if you want to directly show browser's default prompt
    (only for https sites)"
    bind:value={modalSettings.isEnabled}
    error={(error || {}).isEnabled}
    isHorizontal={true} />
  <TextField
    title="Title"
    bind:value={modalSettings.title}
    error={(error || {}).title} />
  <TextField
    title="Content"
    bind:value={modalSettings.content}
    error={(error || {}).content} />
  <TextField
    title="Accept button text"
    bind:value={modalSettings.acceptText}
    error={(error || {}).acceptText} />
  <TextField
    title="Reject button text"
    bind:value={modalSettings.rejectText}
    error={(error || {}).rejectText} />
  <ImageIcon type="icon" label="Icon" bind:value={modalSettings.iconUrl} />

  <Dropdown
    title="Dialog position"
    bind:value={modalSettings.position}
    options={dialogPositions} />
  <Dropdown
    title="Dialog position in mobile"
    bind:value={modalSettings.mobilePosition}
    options={dialogMobilePositions} />

  <TextField
    title="Dialog retry time"
    description="How much time in seconds prompt will not show if user click on
    reject button"
    placeholder="Dialog retry time (seconds)"
    bind:value={modalSettings.retry}
    error={(error || {}).retry} />
  <Dropdown
    title="Text direction"
    bind:value={modalSettings.direction}
    options={dialogDirections} />

  <div class="buttons is-centered">
    <button
      class="button is-success is-outlined"
      on:click={save}
      class:is-loading={inprogress}
      disabled={inprogress}>
      Save Items
    </button>
  </div>
</div>
